module.exports = __webpack_public_path__ + "img/5.199c64a9.png";